/* eslint-disable */
<template>
    <div class="container" style="padding-left: 150px; padding-right: 150px">

        <v-card class="upload-container pa-7">
            <v-card-title>Laadi üles logifailide kaust</v-card-title>

            <v-spacer></v-spacer>

            <v-card-text>
                <v-alert
                    v-if="this.errorMessage"
                    class="mb-6"
                    color="red"
                    variant="tonal"
                >
                    {{ this.errorMessage }}
                </v-alert>

                <v-file-input
                    clearable
                    label="Vali fail..."
                    variant="solo-filled"
                    prepend-icon="mdi-folder-upload"
                    @change="upload"
                ></v-file-input>

            </v-card-text>


            <v-card-text>
                <div class="text-overline pb-2">
                    Analüüsi ajavahemik
                </div>
                <v-radio-group v-model="periodSelection" class="pl-2">
                    <v-radio label="Kõik logid" value="all"></v-radio>
                    <v-radio label="Viimane nädal" value="week"></v-radio>
                    <v-radio label="Muu ajavahemik" value="custom"></v-radio>
                    <v-col class="pl-12" style="max-width: 360px">
                        <label>Algusaeg: </label>
                        <flatPickr :config="config" class="form-control" :disabled="periodSelection !== 'custom'" v-model="selectedStartDate"/>
                        <label>Lõppaeg: </label>
                        <flatPickr :config="config" class="form-control" :disabled="periodSelection !== 'custom'" v-model="selectedEndDate" />
                    </v-col>
                </v-radio-group>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="#3F51B5"
                    type="submit"
                    variant="elevated"
                    :disabled="loading"
                    :loading="loading"
                    @click="analyse"
                >
                    Analüüsi
                </v-btn>
            </v-card-actions>

        </v-card>
    </div>
</template>

<script>
import axios from "axios";
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css'
import { Estonian } from "flatpickr/dist/l10n/et.js"

export default {
    components: {
        flatPickr
    },
    data() {
        return {
            uploadedFile: undefined,
            periodSelection: 'all', // all, week, custom
            errorMessage: '',
            startDate: undefined,
            endDate: undefined,
            selectedStartDate: new Date(new Date().setHours(8, 0, 0, 0)).toISOString(),
            selectedEndDate:new Date(new Date().setHours(23, 59, 0, 0)).toISOString(),
            uploadFailed: false,
            loading: false,
            config: {
                locale: Estonian,
                enableTime: true,
                //dateFormat: "d-m-Y",
            }
        }
    },

    methods: {

        upload(e) {
            this.uploadedFile = e.target.files[0];
        },

        analyse() {
            if (!this.uploadedFile) {
                this.errorMessage = 'Vali zip-fail või logifail.';
                return;
            }

            if (!this.validateDates()) {
                this.errorMessage = 'Valitud alguskuupäev peab olema enne lõpukuupäeva.'
                return;
            }

            this.loading = true;

            const path = this.uploadedFile.name.endsWith('.zip') ? 'zip' : 'single';
            axios.post('/analysis/' + path, this.createRequestData(), {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }})
                .then((response) => {
                    this.loading = false;
                    this.$emit('analysis', response.data);
                })
                .catch(() => {
                    this.loading = false;
                    this.uploadFailed = true;
                    this.errorMessage = 'Faili üleslaadimine ebaõnnestus. Kontrolli, et valitud fail on õiges' +
                        ' formaadis (.zip, .json või .log).'
                })
        },

        validateDates() {
            if (this.periodSelection === 'custom') {
                this.startDate = new Date(this.selectedStartDate);
                this.endDate = new Date(this.selectedEndDate);
                return this.startDate <= this.endDate;
            }
            if (this.periodSelection === 'week') {
                this.endDate = new Date();
                this.startDate = new Date(this.endDate.getTime() - 7 * 24 * 60 * 60 * 1000);
            }
            console.log("Start: " + this.startDate);
            console.log("End: " + this.endDate);
            return true;
        },

        createRequestData() {
            const form = new FormData();
            form.append('logs', this.uploadedFile)
            if (this.periodSelection !== 'all') {
                form.append('start', this.startDate.toISOString());
                form.append('end', this.endDate.toISOString());
            }
            return form;
        }
    },
}
</script>

<style scoped>

.upload-container {
    top: 50%;
}

</style>